<template>
  <Drag
    class="monitorCenter"
    :min-width="300"
    defaultWidth="300px"
  >
    <LeftContent
      slot="left"
      :vehInfo.sync="vehInfo"
      :selectMonitorInfo.sync="selectMonitorInfo"
      :vehGroup.sync="vehGroup"
      :vehIndices.sync="vehIndices"
      :electricData.sync="electricData"
      :selectElectricData.sync="selectElectricData"
      :monitorInfo.sync="monitorInfo"
      :cyclePagger.sync="cyclePagger"
      :type.sync="type"
      :refresh="refresh"
      @updateGroup="handleGroupData"
      @onZoomMarker="ZoomMarker()"
      class="monitorCenter__left"
    />
    <div
      class="monitorCenter__right"
      slot="right"
    >
      <BatteryDataDialog
        :visible.sync="batteryVisible"
        :batteryData.sync="batteryData"
        :type.sync="batteryType"
      />
      <div class="monitorCenter__content">
        <div class="monitorCenter__upside">
          <div class="monitorCenter__update-time">
            <span class="mr-30">数据更新时间：{{nowDate}}</span>
            <span class="mr-30" v-if="selectMonitorInfo">软件版本号：{{selectMonitorInfo.softwareVersion}}</span>
            <span class="mr-30" v-if="selectMonitorInfo">硬件版本号：{{selectMonitorInfo.hardwareVersion}}</span>
            <span class="mr-30" v-if="selectMonitorInfo">sn号：{{selectMonitorInfo.sn}}</span>
          </div>
            <!-- 刷新位置开始 -->
              <div
                v-show="refresh.timer"
                class="export"
              >
                <el-button type="primary" size="mini" @click="onExport">导出</el-button>
              </div>
              <div
                class="refresh"
                v-show="refresh.timer"
                style="right:100px;"
              >
                <span class="refresh__num">{{refresh.num}}</span>秒后刷新
              </div>
              <!-- 刷新位置结束 -->
          <!-- 电池信息开始 -->
          <el-row class="monitorCenter__chart" >
            <el-col :span="4">
              <div class="battery">
                <div>
                  <!-- 电池图形 -->
                  <Battery :visible="visible" :percentage.sync="SOC"/>
                </div>
                <div
                  class="battery__item"
                  v-if="visible"
                  :title="'工作状态:'+workState"
                >
                  <span class="battery__label">工作状态</span>
                  <span class="battery__text battery__text_warning">{{workState||"暂无数据"}}</span>
                </div>
                <div
                  class="battery__item"
                  v-if="visible"
                  :title="'电池类型:'+bmsType"
                >
                  <span class="battery__label">电池类型</span>
                  <span class="battery__text battery__text_primary">{{bmsType||"暂无数据"}}</span>
                </div>
                <div
                  class="battery__item"
                  v-if="!visible"
                >
                  <span style="color:#00D3B8">请先选择设备</span>
                </div>
              </div>
            </el-col>
            <el-col :span="20">
              <BatteryInfo
                :selectMonitorInfo="selectMonitorInfo"
                @getAll="getAll"
              />
            </el-col>
          </el-row>
          <!-- 电池信息结束 -->

          <!-- 电池图表开始 -->
          <CardInfo :selectMonitorInfo="selectMonitorInfo" />
          <el-row
            v-if="false"
            type="flex"
            class="monitorCenter__chart">
            <el-col
              :span="5"
              class="chart-card">
              <div class="chart-card__title">SOC电量</div>
              <Chart
                class="chart-card__content"
                :option="capacityChartOption"
              />
            </el-col>
            <el-col
              :span="5"
              class="chart-card"
            >
              <div class="chart-card__title">总电压</div>
              <Chart
                class="chart-card__content"
                :option="interValChartOption"
              />
            </el-col>
            <el-col
              :span="5"
              class="chart-card"
            >
              <div class="chart-card__title">电流统计</div>
              <Chart
                class="chart-card__content"
                :option="countChartOption"
              />
            </el-col>
          </el-row>
          <!-- 电池图表结束 -->
        </div>

        <div class="monitorCenter__underside">
          <!-- 电芯统计开始 -->
          <div class="monitorCenter__underside-item">
            <!-- 电芯统计 -->
            <BatteryFaultCount
              :batteryType.sync="batteryType"
              :data.sync="batteryCount"
              :list.sync="batteryList"
              :tempList.sync="tempList"
            />
          </div>
          <!-- 电芯统计结束 -->
          <div class="monitorCenter__underside-item">
            <!-- 地图开始 -->
            <!-- <MonitorMap v-show="false" :vehInfo.sync="vehInfo" :vehIndices="vehIndices" /> -->
            <div
              class="monitorCenter__map"
              ref="map"
              :style="{top: isMapEnlarge ? 0 : '61%', left: isMapEnlarge ? 0 : 'calc(50% + 8px)'}"
            >
              <i
                @click="isMapEnlarge = !isMapEnlarge"
                class="monitorCenter__map-zoom iconfont"
                :class="isMapEnlarge ? 'icon-suoxiao' : 'icon-enlarge'"
              />
              <!-- 刷新位置开始 -->
              <div
                v-show="refresh.timer"
                class="export"
              >
                <el-button type="primary" size="mini" @click="onExport">导出</el-button>
              </div>
              <div
                class="refresh"
                v-show="refresh.timer"
              >
                <span class="refresh__num">{{refresh.num}}</span>秒后刷新
              </div>
              <!-- 刷新位置结束 -->
            </div>
            <!-- 地图结束 -->
            <!-- 信息窗口开始 -->
            <InfoWindow
              ref="InfoWindow"
              :vehInfo.sync="vehInfo"
              @onClose="infoWindow.close()"
              v-if="vehInfo"
            />
            <!-- 信息窗口结束 -->
          </div>
        </div>
      </div>
    </div>

  </Drag>
</template>
<!--先BatteryInfo.vue的getAll生成数据去到BatteryDataDialog.vue中判断展示对应的设备类型组件-->
<script>
import { mapState,mapMutations } from "vuex";
import day from "dayjs";
import GPS from "@/assets/js/GPS";
import { getCarIcon } from "@/assets/js/base";
import Chart from "@/components/Chart/index.vue";
import Battery from "./Battery.vue";
import BatteryInfo from "./BatteryInfo.vue";
// import Gauge from "./Gauge.vue";
import BatteryFaultCount from "./BatteryFaultCount.vue";
import Drag from "@/components/Drag/index.vue";
import LeftContent from "./LeftContent.vue";
import InfoWindow from "./InfoWindow.vue";
import CardInfo from "./CardInfo.vue";
import BatteryDataDialog from "@/components/BatteryDataDialog/index.vue";
export default {
  components: {
    Chart,
    Battery,
    BatteryInfo,
    // Gauge,
    BatteryFaultCount,
    Drag,
    LeftContent,
    InfoWindow,
    BatteryDataDialog,
    CardInfo
  },

  data() {
    return {
      list: [
        { title: "这是一个标题1", status: 0 },
        { title: "这是一个标题2", status: 1 },
        { title: "这是一个标题3", status: 2 },
        { title: "这是一个标题4", status: 1 },
        { title: "这是一个标题5", status: 2 }
      ],
      batteryVisible: false,
      batteryData: null,
      batteryType: "",
      nowDate: day(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      tempTag: 2,
      mosTemp: 0,
      environmentTemp: 0,
      balanceTemp: 0,
      powerBoardTemp: 0,
      capacityChartOption: {},
      interValChartOption: {},
      countChartOption: {},
      type: 3, //查询类型 0:在线 1：离线 2：休眠 3：全部（从未上线） 4：过期
      cyclePagger: 1, //轮询时展示的数据页码
      map: null,
      isMapEnlarge: false, //地图是否放大
      infoWindow: {
        instance: null,
        visible: false
      }, //当前信息窗口
      markerMap: new Map(), //当前地图车辆
      vehGroup: { gids: new Set(), data: [] }, //当前选择所有组织下的所有设备基本信息
      vehIndices: { value: new Map(), timestamp: 0 }, //当前已选所有设备地图信息
      vehInfo: null, //当前选择设备地图信息
      monitorInfo: { value: new Map(), timestamp: 0 }, //当前已选所有设备电池信息
      electricData: { value: new Map(), timestamp: 0 }, //当前已选所有电流曲线信息
      selectElectricData: null, //当前选择的设备的电流曲线信息
      selectMonitorInfo: null, //当前选择的设备的电池信息
      defelectricData: [{ label: 0, value: 0 }],
      visible: false,
      workState: "-",
      SOC: "-",
      bmsType: "-",
      defBetteryDate: [],
      defmonitorInfo: [
        { label: "电池编号:", value: "-", type: "info" },
        { label: "总电压", value: "-", type: "info" },
        { label: "电池超温", value: "-", type: "info" },
        { label: "过压保护", value: "-", type: "info" },
        { label: "充电总时间", value: "-", type: "info" },
        { label: "版本号", value: "-", type: "info" },
        { label: "最低电压", value: "-", type: "info" },
        { label: "欠压保护", value: "-", type: "error" },
        { label: "均衡开闭", value: "-", type: "info" },
        { label: "放电总时间", value: "-", type: "info" },
        { label: "电芯数量", value: "-", type: "info" },
        { label: "最高电压", value: "-", type: "info" },
        { label: "放电保护", value: "-", type: "info" },
        { label: "充电保护", value: "-", type: "info" },
        { label: "温度数量", value: "-", type: "info" },
        { label: "充电次数", value: "-", type: "info" },
        { label: "剩余电容量", value: "-", type: "info" },
        { label: "相差电压", value: "-", type: "warning" },
        { label: "短路次数", value: "-", type: "info" },
        { label: "设计容量", value: "-", type: "info" },
        { label: "循环次数", value: "-", type: "info" },
        { label: "出厂日期", value: "-", type: "info" },
        { label: "均衡电压", value: "-", type: "info" },
        { label: "设备编号", value: "-", type: "info" }
      ],
      defmonitorInfoHERCULES:[
        { label: "电池编号:", value: "-", type: "info" },
        { label: "总电压", value: "-", type: "info" },
        { label: "电池超温", value: "-", type: "info" },
        { label: "过压保护", value: "-", type: "info" },
        { label: "充电总时间", value: "-", type: "info" },
        { label: "版本号", value: "-", type: "info" },
        { label: "最低电压", value: "-", type: "info" },
        { label: "欠压保护", value: "-", type: "error" },
        { label: "均衡开闭", value: "-", type: "info" },
        { label: "放电总时间", value: "-", type: "info" },
        { label: "电芯数量", value: "-", type: "info" },
        { label: "最高电压", value: "-", type: "info" },
        { label: "放电保护", value: "-", type: "info" },
        { label: "充电保护", value: "-", type: "info" },
        { label: "温度数量", value: "-", type: "info" },
        { label: "充电次数", value: "-", type: "info" },
        { label: "剩余电容量", value: "-", type: "info" },
        { label: "相差电压", value: "-", type: "warning" },
        { label: "短路次数", value: "-", type: "info" },
        { label: "设计容量", value: "-", type: "info" },
        { label: "循环次数", value: "-", type: "info" },
        { label: "出厂日期", value: "-", type: "info" },
        { label: "均衡电压", value: "-", type: "info" },
        { label: "设备编号", value: "-", type: "info" }
      ],
      betterDefmonitorInfo: [
        { label: "温度数量", value: "-", type: "info" },
        { label: "报警状态", value: "-", type: "info" },
        { label: "电池数量", value: "-", type: "info" },
        { label: "电池编号", value: "-", type: "info" },
        { label: "电池类型", value: "-", type: "info" },
        { label: "充电保护", value: "-", type: "info" },
        { label: "出厂日期", value: "-", type: "info" },
        { label: "电压差值", value: "-", type: "info" },
        // { label: "数据时间", value: "-", type: "info" },
        { label: "放电保护", value: "-", type: "info" },
        { label: "机器编码", value: "-", type: "info" },
        { label: "最高温度", value: "-", type: "info" },
        { label: "最高电压", value: "-", type: "info" },
        { label: "最低温度", value: "-", type: "info" },
        { label: "最低电压", value: "-", type: "info" },
        { label: "剩余电容量", value: "-", type: "info" },
        { label: "电流", value: "-", type: "info" },
        { label: "总电压", value: "-", type: "info" },
        { label: "循环次数", value: "-", type: "info" },
        { label: "终端编号", value: "-", type: "info" }
      ],
      betterDefmonitorInfoLD_01A: [
        { label: "温度数量", value: "-", type: "info" },
        { label: "报警状态", value: "-", type: "info" },
        { label: "电池数量", value: "-", type: "info" },
        { label: "电池编号", value: "-", type: "info" },
        { label: "电池类型", value: "-", type: "info" },
        { label: "充电保护", value: "-", type: "info" },
        { label: "出厂日期", value: "-", type: "info" },
        { label: "电压差值", value: "-", type: "info" },
        // { label: "数据时间", value: "-", type: "info" },
        { label: "放电保护", value: "-", type: "info" },
        { label: "机器编码", value: "-", type: "info" },
        { label: "最高温度", value: "-", type: "info" },
        { label: "最高电压", value: "-", type: "info" },
        { label: "最低温度", value: "-", type: "info" },
        { label: "最低电压", value: "-", type: "info" },
        { label: "剩余电容量", value: "-", type: "info" },
        { label: "电流", value: "-", type: "info" },
        { label: "总电压", value: "-", type: "info" },
        { label: "循环次数", value: "-", type: "info" },
        { label: "终端编号", value: "-", type: "info" }
      ],
      betterDefmonitorInfoSUNWODA: [
        { label: "温度数量", value: "-", type: "info" },
        { label: "报警状态", value: "-", type: "info" },
        { label: "电池数量", value: "-", type: "info" },
        { label: "电池编号", value: "-", type: "info" },
        { label: "电池类型", value: "-", type: "info" },
        { label: "充电保护", value: "-", type: "info" },
        { label: "出厂日期", value: "-", type: "info" },
        { label: "电压差值", value: "-", type: "info" },
        // { label: "数据时间", value: "-", type: "info" },
        { label: "放电保护", value: "-", type: "info" },
        { label: "机器编码", value: "-", type: "info" },
        { label: "最高温度", value: "-", type: "info" },
        { label: "最高电压", value: "-", type: "info" },
        { label: "最低温度", value: "-", type: "info" },
        { label: "最低电压", value: "-", type: "info" },
        { label: "剩余电容量", value: "-", type: "info" },
        { label: "电流", value: "-", type: "info" },
        { label: "总电压", value: "-", type: "info" },
        { label: "循环次数", value: "-", type: "info" },
        { label: "终端编号", value: "-", type: "info" }
      ],
      defpile: [{ label: 0, value: 0 }],
      defChartData: [{ label: 0, value: 0 }],
      batteryCount: { normal: 0, error: 0 },
      batteryList: [],

      tempList: [],
      vid: null, //当前车辆id
      vehsLimit: 100, //当前地图车辆限制, 超过100开启聚合
      cluster: {
        instance: null, //点聚合实例
        visible: true
      },
      refresh: {
        //轮询定时器
        timer: null,
        num: 0
      }
    };
  },
  computed: {
    ...mapState(["USER"])
  },
  watch: {
    USER: {
        //根据设备类型判断数据
        handler(val) {
            if (val.loginPage === "GPRS-XINGHENG") {
                this.defBetteryDate = this.defmonitorInfo;
            } else if (val.loginPage === "GPRS-BETTER") {
                this.defBetteryDate = this.betterDefmonitorInfo;
            } else if (val.loginPage === "GPRS-PEICHENG") {
                this.defBetteryDate = "";
            }else if (val.loginPage === "GPRS-DALI") {
                this.defBetteryDate = "";
            }else if (val.loginPage === "GPRS-HERCULES") {
               this.defBetteryDate = this.defmonitorInfoHERCULES;
            }else if (val.loginPage === "LD-01A") {
               this.defBetteryDate = this.betterDefmonitorInfoLD_01A;
            }else if (val.loginPage === "GPRS-SUNWODA") {
               this.defBetteryDate = this.betterDefmonitorInfoSUNWODA;
            }
        },
        deep: true,
        immediate: true
    },
    defmonitorInfoHERCULES(set){
        this.defBetteryDate = set;
    },
    betterDefmonitorInfoLD_01A(set){
        this.defBetteryDate = set;
    },
    betterDefmonitorInfoSUNWODA(set){
        this.defBetteryDate = set;
    },
    //监听索引变化
    vehIndices(val) {
      //处理索引变化
      this.handleIndices();
      //重新刷新轮询
      this.handlePolingRefresh();
    },
    selectElectricData(val) {
      if (val === -1 || val === null) {
        this.clearData();
        this.initCapacityChart();
        this.initInterValChart();
        this.initCountChartOption();
        return;
      }
      this.defelectricData = [{ label: 0, value: 0 }];
      this.defpile = [{ label: 0, value: 0 }];
      this.defChartData = [{ label: 0, value: 0 }];
      for (let i in val) {
        this.defelectricData[i] = {
          label: val[i].devTime || 0,
          value: val[i].pileElectric || 0
        };
        this.defpile[i] = {
          label: val[i].devTime || 0,
          value: val[i].pileCopacity || 0
        };
        this.defChartData[i] = {
          label: val[i].devTime || 0,
          value: val[i].pileVoltage || 0
        };
      }
      if (val && val.length === 0) {
        for (let i in this.defelectricData) {
          this.defelectricData[i] = { label: 0, value: 0 };
        }
        for (let i in this.defpile) {
          this.defpile[i] = { label: 0, value: 0 };
        }
        for (let i in this.defChartData) {
          this.defChartData[i] = { label: 0, value: 0 };
        }
      }
      this.initCountChartOption();
    },
    selectMonitorInfo(val) {
      // if (val && val.COMPANY != undefined) {
      //   this.batteryType = val.COMPANY.split("-")[1];
      //   if (this.batteryType === "XINGHENG") {
      //     this.tempTag = 2;
      //     this.setDefmonitorInfo(val);
      //   } else if (this.batteryType === "BETTER") {
      //     this.tempTag = 2;
      //     this.setBetterDefmonitorInfo(val);
      //   }
      // }
      if (this.vehInfo && this.vehInfo.T != undefined) {
        this.COMMIT_ACTIVE_CLS(this.vehInfo.T)//存储当前设备
        this.batteryType = this.vehInfo.T.split("-")[1];
        if (this.batteryType === "XINGHENG") {
          this.tempTag = 2;
          this.setDefmonitorInfo(val);
        } else if (this.batteryType === "BETTER") {
          this.tempTag = 2;
          this.setBetterDefmonitorInfo(val);
        }else if (this.batteryType === "DALI") {
        //   this.tempTag = 2;
        //   this.setBetterDefmonitorInfo(val);
        }else if (this.batteryType === "HERCULES") {
          this.tempTag = 2;
          this.setHerculesdefmonitorInfo(val);
        }else if (this.batteryType === "01A") {//新添加设备
          this.tempTag = 2;
          this.setHerculesdefmonitorInfoLD_01A(val);
        }else if (this.batteryType === "SUNWODA") {//新添加设备
          this.tempTag = 2;
          this.setHerculesdefmonitorInfoSUNWODA(val);
        }
      }
      // if (this.USER.loginPage === "GPRS-XINGHENG") {
      //   this.setDefmonitorInfo(val);
      // } else if (this.USER.loginPage === "GPRS-BETTER") {
      //   this.setBetterDefmonitorInfo(val);
      // }
      if (val === undefined || val === null) {
        this.clearData();
        this.initCapacityChart();
        this.initInterValChart();
        this.initCountChartOption();
        return;
      }

      //赋值SOC电量 总电压 电流统计 MOS温度 环境温度 均衡板温度 功率板温度对应的值
      this.visible = true;
      this.mosTemp = val.mosTemp;
      this.environmentTemp = val.environmentTemp;
      this.balanceTemp = val.balanceTemp;
      this.powerBoardTemp = val.powerBoardTemp;
      this.batteryCount = {
        normal: val.commonNum || 0,
        error: val.errorNum || 0
      };
      this.workState = val.cdStatusName;
      this.SOC = parseFloat(val.remainingBatteryCapacity);
      this.bmsType = val.batteryTypeName;
      this.nowDate = val.devTime || day(new Date()).format("YYYY-MM-DD HH:mm:ss");
      this.batteryList = val.list;
      this.tempList = val.temperatures;
      this.initCapacityChart();
      this.initInterValChart();
    },
    vehInfo: {
      async handler(nowVal, curVal) {
        if (!nowVal) return;
        //map setCenter LngLat
        if (!curVal || nowVal.vehicleId !== curVal.vehicleId) {
          this.ZoomMarker();
        }
      },
      deep: true,
      immediate: true
    }
  },
  async mounted() {
    this.batteryType = this.USER.loginPage.split("-")[1];
    await this.$sleep();
    this.initCapacityChart();
    this.initInterValChart();
    this.initCountChartOption();
    this.initMap();
  },

  methods: {
    ...mapMutations(['COMMIT_ACTIVE_CLS']),
    // 导出
    onExport(){
      let params = {
        terminalNo:this.vehInfo ? this.vehInfo.terminalNo : '',
      }
      this.$API.exportDeviceRealBMSData(params);
    },
    async setDefmonitorInfo(val) {
      const bmsData = [
        val.bmsNo,
        val.pileVoltage,
        val.temOverNum,
        val.monomerOverVoltage,
        val.chargeSpaceTime,
        "暂无数据",
        val.minVoltage,
        val.voltageOverDischarge,
        val.balanceFlag,
        val.dischargeSpaceTime,
        val.batteryCount,
        val.maxVoltage,
        val.dischargeOver,
        val.chargeOver,
        val.TempNum,
        val.chargeNum,
        val.pileCopacity,
        val.deltaVoltage,
        val.shortCircuitNum,
        val.designCharge,
        val.circulateNum,
        val.createTime,
        val.avgVoltage,
        val.terminalNo
      ];
      const bms = this.dataFormat(bmsData);
      this.defBetteryDate = [
        { label: "电池设备号", value: this.dataUnit(bms[0]), type: "info" },
        { label: "总电压", value: this.dataUnit(bms[1], "V"), type: "info" },
        { label: "电池超温", value: this.dataUnit(bms[2], "次"), type: "info" },
        {
          label: "过压保护",
          value: this.dataUnit(bms[3]) === 1 ? "单体过压保护" : "无",
          type: "info"
        },
        {
          label: "充电总时间",
          value: this.dataUnit(bms[4]),
          type: "info"
        },
        { label: "版本号", value: this.dataUnit(bms[5]), type: "info" },
        { label: "最低电压", value: this.dataUnit(bms[6], "V"), type: "info" },
        {
          label: "欠压保护",
          value: this.dataUnit(bms[7]) === 1 ? "总压过放保护" : "无",
          type: "error"
        },
        {
          label: "均衡开闭",
          value: this.dataUnit(bms[8]) === 0 ? "开启" : "关闭",
          type: "info"
        },
        {
          label: "放电总时间",
          value: this.dataUnit(bms[9]),
          type: "info"
        },
        {
          label: "电芯数量",
          value: this.dataUnit(bms[10], "串"),
          type: "info"
        },
        { label: "最高电压", value: this.dataUnit(bms[11], "V"), type: "info" },
        {
          label: "放电保护",
          value: this.dataUnit(bms[12]) === 0 ? "无" : "开启",
          type: "info"
        },
        {
          label: "充电保护",
          value: this.dataUnit(bms[13]) === 0 ? "无" : "开启",
          type: "info"
        },
        {
          label: "温度数量",
          value: this.dataUnit(bms[14], "个"),
          type: "info"
        },
        {
          label: "充电次数",
          value: this.dataUnit(bms[15], "次"),
          type: "info"
        },
        { label: "剩余电容量", value: this.dataUnit(bms[16], "A"), type: "info" },
        {
          label: "相差电压",
          value: this.dataUnit(bms[17], "V"),
          type: "warning"
        },
        {
          label: "短路次数",
          value: this.dataUnit(bms[18], "次"),
          type: "info"
        },
        { label: "设计容量", value: this.dataUnit(bms[19], "A"), type: "info" },
        {
          label: "循环次数",
          value: this.dataUnit(bms[20], "次"),
          type: "info"
        },
        {
          label: "出厂日期",
          value: day(this.dataUnit(bms[21])).format("YYYY-MM-DD"),
          type: "info"
        },
        { label: "均衡电压", value: this.dataUnit(bms[22], "V"), type: "info" },
        { label: "设备编号", value: this.dataUnit(bms[23]), type: "info" }
      ];
    },
    async setBetterDefmonitorInfo(val) {
      const bmsData = [
        val.TempNum,
        val.alarmState,
        val.batteryCount,
        val.bmsNo,
        val.bmsType,
        val.chargingProtectionFailure,
        val.createTime,
        val.deltabattery,
        val.disChargingProtectionFailure,
        val.machineCode,
        val.maxTemp,
        val.maxbattery,
        val.minTemp,
        val.minbattery,
        val.pileCopacity,
        val.pileElectric,
        val.pileVoltage,
        val.recyclingNum,
        val.terminalNo
      ];
      const bms = this.dataFormat(bmsData);
      this.defBetteryDate = [
        { label: "温度数量", value: this.dataUnit(bms[0]), type: "info" },
        {
          label: "报警状态",
          value: this.dataUnit(bms[1]) === 0 ? "正常" : "报警",
          type: "info"
        },
        { label: "电池数量", value: this.dataUnit(bms[2]), type: "info" },
        { label: "电池编号", value: this.dataUnit(bms[3]), type: "info" },
        { label: "电池类型", value: this.dataUnit(bms[4]), type: "info" },
        {
          label: "充电保护",
          value: this.dataUnit(bms[5]) === 1 ? "失效" : "正常",
          type: "info"
        },
        { label: "出厂日期", value: this.dataUnit(bms[6]), type: "info" },
        { label: "电压差值", value: this.dataUnit(bms[7]), type: "info" },
        // { label: "数据时间", value: this.dataUnit(bms[8]), type: "info" },
        {
          label: "放电保护",
          value: this.dataUnit(bms[8]) === 1 ? "失效" : "正常",
          type: "info"
        },
        { label: "机器编码", value: this.dataUnit(bms[9]), type: "info" },
        { label: "最高温度", value: this.dataUnit(bms[10], "℃"), type: "info" },
        { label: "最高电压", value: this.dataUnit(bms[11], "V"), type: "info" },
        { label: "最低温度", value: this.dataUnit(bms[12], "℃"), type: "info" },
        { label: "最低电压", value: this.dataUnit(bms[13], "V"), type: "info" },
        {
          label: "剩余电容量",
          value: this.dataUnit(bms[14], "%"),
          type: "info"
        },
        { label: "电流", value: this.dataUnit(bms[15], "A"), type: "info" },
        { label: "总电压", value: this.dataUnit(bms[16], "V"), type: "info" },
        { label: "循环次数", value: this.dataUnit(bms[17]), type: "info" },
        { label: "终端编号", value: this.dataUnit(bms[18]), type: "info" },
        // { label: "工作状态", value: this.dataUnit(bms[19]), type: "info" }
      ];
    },
    async setHerculesdefmonitorInfo(val) {
        this.defmonitorInfoHERCULES = [];
        for(let item in val.kvMap){
            this.defmonitorInfoHERCULES.push({label:item,value:val.kvMap[item],type: "info"})
        }
        return this.defmonitorInfoHERCULES;
    },
    async setHerculesdefmonitorInfoLD_01A(val) {
        this.betterDefmonitorInfoLD_01A = [];
        for(let item in val.kvMap){
            if(item != 'groupData'){
                this.betterDefmonitorInfoLD_01A.push({label:item,value:val.kvMap[item],type: "info"})
            }
        }
        Object.keys(val.kvMap.groupData).map(item=>{
            for(let key in val.kvMap.groupData[item]){
                this.betterDefmonitorInfoLD_01A.push({label:key,value:val.kvMap.groupData[item][key],type: "info"})
            }
        })
        return this.betterDefmonitorInfoLD_01A;
    },
    async setHerculesdefmonitorInfoSUNWODA(val) {
        this.betterDefmonitorInfoSUNWODA = [];
        for(let item in val.kvMap){
            if(item != 'groupData'){
                this.betterDefmonitorInfoSUNWODA.push({label:item,value:val.kvMap[item],type: "info"})
            }
        }
        return this.betterDefmonitorInfoSUNWODA;
    },
    //获取电池所有信息
    async getAll() {
      if (!this.vehInfo || this.vehInfo.vehicleId === null) return;
      // const options = [
      //   "GPRS-XINGHENG",
      //   "GPRS-BETTER",
      //   "GPRS-PEICHENG"
      // ];
      const fn = {
        XINGHENG: "getXINGHENG",
        BETTER: "getBETTER",
        PEICHENG: "getPEICHENG",
        DALI: "getDALI",
        HERCULES: "getHERCULES",
        LD01A: "getLD01A",
        SUNWODA: "getSUNWODA",
      };
      //根据不同设备获取获取参数-做判断是否为新添加设备，获取的数据格式不同
      if(this.vehInfo.T != "GPRS-DALI" && this.vehInfo.T != "GPRS-HERCULES" &&  this.vehInfo.T != "LD-01A" && this.vehInfo.T != "GPRS-SUNWODA"){
          const { data } = await this[fn[this.vehInfo.T.split("-")[1]]]();
          this.batteryType = this.vehInfo.T.split("-")[1];
          this.batteryData = data;
      }else{
            let self = this;
            let data = {
                alarm:{},
                analog:{}
            }
            function generateName(o,name){
                let obj = [];
                for(let item in self.selectMonitorInfo[o]){
                    obj.push({title:item,value:self.selectMonitorInfo[o][item]});
                }
                return obj || [];
            }
            //告警量
            data.alarm.errorStatus = generateName('errorStatus','alarm.errorStatus')||[];
            data.alarm.protectStatus = generateName('protectStatus','alarm.protectStatus')||[];
            data.alarm.systemStatus = generateName('systemStatus','alarm.systemStatus')||[];
            data.alarm.warnStatus = generateName('warnStatus','alarm.warnStatus')||[];
            data.baseInfo = generateName('baseInfo','alarm.baseInfo')||[];
            data.analog.salveTempList = this.selectMonitorInfo.salveTempList?this.selectMonitorInfo.salveTempList:[];
            //模拟量
            data.analog.mapList = this.selectMonitorInfo.mapList?this.selectMonitorInfo.mapList.map((item)=>{return item.coreVoltage;}):[];
            data.analog.tempList = this.selectMonitorInfo.tempList?this.selectMonitorInfo.tempList:[];
            this.batteryData = data;
            data = {alarm:{},analog:{}};
      }
      //console.log(data);
      //
      this.batteryVisible = true;
    },
    //PEICHENG设备参数请求
    async getPEICHENG() {
      console.log("getPEICHENG");
    },
    //BETTER设备参数请求
    async getBETTER() {
      return await this.$API.getMockPileWarnPileInfoBetter({
        vehicleId: this.vehInfo.vehicleId
      });
    },
    //XINGHENG设备参数请求
    async getXINGHENG() {
      return await this.$API.getMockPileWarnPileInfo({
        vehicleId: this.vehInfo.vehicleId
      });
    },
    //DALI设备参数请求
    async getDALI() {
        console.log('getDALI')
    //   return await this.$API.getMockPileWarnPileInfo({
    //     vehicleId: this.vehInfo.vehicleId
    //   });
    },
    //HERCULES设备参数请求
    async getHERCULES() {
        console.log('getHERCULES');
    //   return await this.$API.getMockPileWarnPileInfo({
    //     vehicleId: this.vehInfo.vehicleId
    //   });
    },
    //数据清空
    clearData() {
      this.defBetteryDate.map(item => {
        item.value = "-";
      });
      this.nowDate = day(new Date()).format("YYYY-MM-DD HH:mm:ss");
      this.defpile = [{ label: 0, value: 0 }];
      this.defChartData = [{ label: 0, value: 0 }];
      this.defelectricData = [{ label: 0, value: 0 }];
      this.batteryCount = { normal: 0, error: 0 };
      this.batteryList = [];
      this.tempList = [];
      this.mosTemp = 0;
      this.environmentTemp = 0;
      this.balanceTemp = 0;
      this.powerBoardTemp = 0;
      this.visible = false;
    },
    //数据处理
    dataFormat(arrlist) {
      for (let i in arrlist) {
        if (arrlist[i] === undefined || arrlist[i] === "") {
          arrlist[i] = "-";
        }
      }
      return arrlist;
    },
    //添加单位
    dataUnit(data, unit) {
      if (data != "-" && unit) {
        data = data + unit;
      }
      return data;
    },

    //重新刷新轮询
    handlePolingRefresh() {
      if (this.vehIndices.value.size === 0) {
        clearInterval(this.refresh.timer);
        this.refresh = {
          timer: null,
          num: 0
        };
      } else {
        !this.refresh.timer && this.pollingRefresh();
      }
    },
    //轮询
    pollingRefresh() {
      clearInterval(this.refresh.timer);
      this.refresh.num = 10;
      this.refresh.timer = setInterval(async () => {
        this.refresh.num === 0 ? (this.refresh.num = 10) : this.refresh.num--;
        if (this.refresh.num === 0) {
          if (this.$route.path !== "/monitorCenter") return;
          //每10秒获取车组数据
          try {
            const gids = [...this.vehGroup.gids];
            if (gids.length) {
              const { data } = await this.$API.getVehicleState({
                organizationIds: gids.join(","),
                pagger: this.cyclePagger,
                total: 100,
                type: this.type
              });
              this.handleGroupData(gids, data.MonitoringCenterVos);
            }
          } catch (error) {
            console.error(error);
            this.$msg({
              showClose: true,
              message: error.msg,
              type: "warning"
            });
          }
        }
      }, 1000);
      this.$off("hook:beforeDestroy");
      this.$once("hook:beforeDestroy", () => {
        clearInterval(this.refresh.timer);
      });
    },
    //处理车组数据排序 以及 更新索引内最新数据
    handleGroupData(gids, data) {
      //有多个车组时则需要排序
      if (gids.length > 1) {
        //建立车组点击顺序的映射
        const gidsMap = new Map(gids.map((gid, i) => [gid, i]));
        //按树状图点击先后顺序来排序
        data.sort(
          (a, b) =>
            gidsMap.get(b.organizationId) - gidsMap.get(a.organizationId)
        );
      }

      let vehIndices = new Map(this.vehIndices.value);
      // data.map(item => {
      //   //更新当前车辆信息
      //   this.vehInfo &&
      //     this.vehInfo.vehicleId === item.vehicleId &&
      //     (this.vehInfo = Object.freeze(item));
      //   //更新索引内最新数据
      //   // vehIndices.has(item.vehicleId) &&
      //   //   vehIndices.set(item.vehicleId, item);
      // });

      //更新已选设备索引
      this.vehIndices = {
        value: vehIndices,
        timestamp: Date.now()
      };
      //更新组织数据
      this.vehGroup = {
        data: Object.freeze(data),
        gids: new Set(gids)
      };
    },
    //处理车辆索引变化
    async handleIndices() {
      if (this.$route.path !== "/monitorCenter") return;
      if (this.vehIndices.value.size === 0) {
        this.infoWindow = null;
        this.vehInfo = null;
        //清除点聚合
        this.cluster.instance && this.cluster.instance.clearMarkers();
        this.cluster.instance = null;
        //清除地图上所有点
        this.map && this.map.remove([...this.markerMap.values()]);
        this.markerMap = new Map();
        this.map && this.map.clearMap();
        return;
      }
      this.showVehGroup();
    },
    //多车模式
    async showVehGroup() {
      //清除点聚合
      if (!this.cluster.visible) {
        this.cluster.instance && this.cluster.instance.clearMarkers();
        this.cluster.instance = null;
      }
      let markerMap = this.markerMap;
      //删除索引内不存在的车辆
      [...markerMap.keys()].map(vid => {
        if (!this.vehIndices.value.has(vid)) {
          markerMap.get(vid).setMap(null);
          markerMap.delete(vid);
        }
      });
      //添加或删除车辆
      let renderNum = 0;
      let changeNum = 0;
      const vehs = [...this.vehIndices.value.values()];
      for (let i = 0; i < vehs.length; i++) {
        const nowVehInfo = { ...vehs[i] }; //复制防止内存泄露
        //如果markerMap内存有该车辆
        if (markerMap.has(nowVehInfo.vehicleId)) {
          const { lon, lat } = GPS.gcj_encrypt(nowVehInfo.Y, nowVehInfo.X);
          const marker = markerMap.get(nowVehInfo.vehicleId);
          const oldVehInfo = marker.getExtData(); //获取旧数据
          marker.setExtData(nowVehInfo); //设置最新数据
          //超过数量限制则代表开聚合，不setMap影响性能
          vehs.length > this.vehsLimit
            ? marker.setMap(null)
            : marker.setMap(this.map);

          if (nowVehInfo.X !== oldVehInfo.X || nowVehInfo.Y !== oldVehInfo.Y) {
            //位置改变时才设置车辆位置
            changeNum++;
            await batchSetPosition.bind(this)(
              marker,
              [lon, lat],
              changeNum,
              50,
              50
            );
          }

          if (nowVehInfo.state !== oldVehInfo.state) {
            //如果图片信息有变化则重新设置图片
            changeNum++;
            await batchSetContent.bind(this)(
              marker,
              nowVehInfo,
              changeNum,
              50,
              50
            );
          }
        } else {
          //如果markerMap内没存有该车辆
          renderNum++;
          await batchMarker.bind(this)(nowVehInfo, i, vehs, renderNum, 50, 50); //分批渲染
        }
      }

      //地图上车辆大于100辆自动开启聚合
      if (
        !this.cluster.visible &&
        this.vehIndices.value.size > this.vehsLimit
      ) {
        this.cluster.visible = true;
        this.$msg({
          showClose: true,
          message: `由于地图车辆超过${this.vehsLimit}辆, 开启聚合以优化性能`,
          type: "warning"
        });
      }
      //设置点聚合
      this.cluster.visible && this.toggleCluster();

      //分批设置marker Content
      function batchSetContent(marker, item, changeNum, num, ms) {
        //changeNum代表当前渲染到多少辆了， num代表每多少辆暂停会执行， ms代表暂停多少毫秒
        return new Promise(resolve => {
          marker.setContent(
            `<img style="width: 32px;height:35px;transform: rotate(${
              item.F
            }deg);" src="${getCarIcon(item)}" />`
          );

          if (changeNum % num === 0) {
            //每num辆则等ms再渲染
            setTimeout(() => {
              resolve();
            }, ms);
          } else {
            resolve();
          }
        });
      }
      //分批设置marker位置
      function batchSetPosition(marker, position, changeNum, num, ms) {
        //changeNum代表当前渲染到多少辆了， num代表每多少辆暂停会执行， ms代表暂停多少毫秒
        return new Promise(resolve => {
          marker.setPosition(new AMap.LngLat(...position));

          if (changeNum % num === 0) {
            //每num辆则等ms再渲染
            setTimeout(() => {
              resolve();
            }, ms);
          } else {
            resolve();
          }
        });
      }
      //分批渲染函数
      function batchMarker(item, index, vehs, renderNum, num, ms) {
        //renderNum代表当前渲染到多少辆了， num代表每多少辆暂停会执行， ms代表暂停多少毫秒
        return new Promise(resolve => {
          const { lon, lat } = GPS.gcj_encrypt(item.Y, item.X);
          // const { lon, lat } = GPS.gcj_encrypt(23.01252,114.34089);
          let marker = new AMap.Marker({
            map: vehs.length > this.vehsLimit ? null : this.map,
            position: [lon, lat], // 位置
            offset: new AMap.Pixel(-16, -17.5), // 设置图标偏移度
            content: `<img style="width: 32px;height:35px;transform: rotate(${
              item.F
            }deg);" src="${getCarIcon(item)}" />`,
            label: {
              content: `<div class="bsj-infowindow"><span>${item.bmsNo}</span></div>` //设置文本标注内容
            },
            extData: item
          });

          marker.on("click", () => {
            //更新车辆信息
            this.vehInfo = Object.freeze(item);
            console.log(this.vehInfo)
            item.vehicleId === this.vehInfo.vehicleId &&
              this.infoWindow.open(this.map);
          });
          this.markerMap.set(item.vehicleId, marker);

          if (renderNum % num === 0) {
            //每num辆则等ms再渲染
            setTimeout(() => {
              resolve();
            }, ms);
          } else {
            resolve();
          }
        });
      }
    },
    //移至当前车辆
    async ZoomMarker() {
      if (!this.$refs.InfoWindow) await this.$nextTick();
      const { lon, lat } = GPS.gcj_encrypt(this.vehInfo.Y, this.vehInfo.X);
      console.log(lon, lat)
      this.infoWindow = new AMap.InfoWindow({
        offset: new AMap.Pixel(0, -10),
        isCustom: true,
        autoMove: false,
        content: this.$refs.InfoWindow.$el
      });

      this.infoWindow.open(this.map, [lon, lat]);
      this.map.setCenter([lon, lat]);
      this.map.panBy(0, 70);
    },
    //设置点聚合
    toggleCluster(flag) {
      if (flag) {
        if (
          this.cluster.visible &&
          this.vehIndices.value.size > this.vehsLimit
        ) {
          this.$msg({
            showClose: true,
            message: `地图设备超过${this.vehsLimit}个, 不能关闭`,
            type: "warning"
          });
          return;
        }
        this.cluster.visible = !this.cluster.visible;
        this.cluster.visible
          ? this.$msg({
              showClose: true,
              message: "聚合开启",
              type: "success"
            })
          : this.$msg({
              showClose: true,
              message: "聚合关闭",
              type: "success"
            });
      }

      if (this.cluster.visible) {
        if (this.cluster.instance) {
          this.cluster.instance.setMarkers([...this.markerMap.values()]);
        } else {
          this.markerMap.size > 0 &&
            (this.cluster.instance = new AMap.MarkerClusterer(
              this.map,
              [...this.markerMap.values()],
              { maxZoom: 17, gridSize: 80 }
            ));
        }
      } else {
        this.showVehGroup();
      }
    },
    ///////////////

    getLineChartOptions({ options, color, formatter }) {
      return {
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "cross" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: "10%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: options.map(({ label }) =>
              label === 0 ? "暂无数据" : day(label).format("YYYY-MM-DD HH:mm:ss")
            ),
            axisLabel: {
              color: "rgba(51,51,51,1)"
            },
            axisLine: {
              lineStyle: {
                color: "rgba(223,223,223,1)"
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "rgba(51,51,51,1)",
              formatter
            },
            axisLine: {
              lineStyle: {
                color: "rgba(223,223,223,1)"
              }
            },
            splitLine: {
              lineStyle: {
                color: "rgba(223,223,223,1)"
              }
            }
          }
        ],
        series: [
          {
            name: "",
            type: "line",
            data: options.map(item => item.value),
            itemStyle: {
              normal: { color }
            },
            barWidth: 10,
            barGap: "0%"
          }
        ]
      };
    },
    //电池容量
    initCapacityChart() {
      const options = this.defpile;
      this.capacityChartOption = this.getLineChartOptions({
        options,
        color: "rgba(0,211,184,1)",
        formatter: "{value} %"
      });
    },
    //充放电间隔
    initInterValChart() {
      const options = this.defChartData;
      let obj = this.vehInfo || {};
      // let v = obj.T == 'GPRS-SUNWODA'?"mV":"V"
      let v = "V"
      this.interValChartOption = this.getLineChartOptions({
        options,
        color: "rgba(52,151,234,1)",
        formatter: `{value} ${v}`
      });
    },
    initCountChartOption() {
      var options = this.defelectricData;
      this.countChartOption = {
        xAxis: {
          type: "category",
          data: options.map(({ label }) =>
            label === 0 ? "暂无数据" : day(label).format("YYYY-MM-DD HH:mm:ss")
          ),
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "rgba(51,51,51,1)"
          },
          axisLine: {
            lineStyle: {
              color: "rgba(223,223,223,1)"
            }
          }
        },
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            type: "cross"
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: "10%",
          containLabel: true
        },
        yAxis: {
          type: "value",
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "rgba(51,51,51,1)",
            formatter: "{value} A"
          },
          axisLine: {
            lineStyle: {
              color: "rgba(223,223,223,1)"
            }
          },
          splitLine: {
            lineStyle: {
              color: "rgba(223,223,223,1)"
            }
          }
        },
        textStyle: {
          fontSize: 10,
          color: "white"
        },
        series: [
          {
            data: options.map(({ value }) => value),
            type: "line",
            name: "电流(A)",
            itemStyle: {
              normal: {
                color: "#2BE3EA"
              }
            },
            lineStyle: {
              normal: {
                color: "rgba(52,151,234,1)"
              }
            },
            areaStyle: {
              color: "rgba(52,151,234,.3)"
            }
          }
        ]
      };
    },
    //延迟渲染地图
    initMap() {
      this.map = new AMap.Map(this.$refs.map, {
        center: [105, 37.5],
        zoom: document.body.clientWidth > 1600 ? 4 : 3
      });
    }
    // initMap() {
    //   this.map = new BSJMap.Map(this.$refs.map, {
    //     center: [105, 37.5],
    //     zoom: document.body.clientWidth > 1600 ? 4 : 3
    //   });
    // }
  }
};
</script>

<style lang="scss" scoped>
.monitorCenter {
  $gap: 16px;
  height: 100%;
  background: rgba(248, 248, 248, 1);
  display: flex;
  &__left {
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
  &__right {
    height: 900px;
    background: rgba(248, 248, 248, 1);
    display: flex;
  }
  &__content {
    margin: $gap;
    display: flex;
    flex: 1;
    overflow: hidden;
    flex-direction: column;
    position: relative;
    overflow: hidden;
  }

  &__upside {
    padding: $gap;
    background: #fff;
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  &__chart {
    // flex: 1;
    height: 50%;
    overflow: hidden;
  }

  &__underside {
    margin-top: $gap;
    display: flex;
    height: 39%;
  }

  &__underside-item {
    flex: 1;
    overflow: hidden;
    background: #fff;

    & + & {
      margin-left: $gap;
    }
  }

  &__map {
    position: absolute;
    right: 0;
    bottom: 0;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    transform: transition3d(0, 0, 0);
    transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  }

  &__map-zoom {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 34px;
    height: 34px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: rgba(0, 211, 184, 1);
    user-select: none;
    z-index: 1;

    &:hover {
      opacity: 0.8;
    }
  }

  &__update-time {
    font-size: 12px;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    line-height: 16px;
    padding: 0 16px 32px;
  }
}
.refresh {
  border: 1px solid #ebedf0;
  height: 28px;
  line-height: 28px;
  box-sizing: border-box;
  padding: 0 5px;
  background: #fff;
  border-radius: 3px;
  font-size: 10px;
  z-index: 999;
  box-shadow: 0 0 3px 1px RGBA(16, 68, 114, 0.2);
  font-weight: bold;
  color: #969799;
  position: absolute;
  right: 10px;
  top: 10px;

  &__num {
    color: $primary;
    margin-right: 4px;
  }
}
.export{
  height: 24px;
  line-height: 24px;
  box-sizing: border-box;
  padding: 0 5px;
  border-radius: 3px;
  font-size: 10px;
  z-index: 999;
  font-weight: bold;
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
}
::v-deep .amap-marker-label {
  ::v-deep .bsj-infowindow {
    span {
      &:nth-child(1) {
        font-size: 13px;
        font-weight: bold;
      }

      &:nth-child(2) {
        color: #7d7e80;
        font-size: 10px;
      }
    }
  }
}
::v-deep .amap-info-contentContainer {
  border-radius: 0;
  padding: 0;
}
.battery {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 32px;

  &__item {
    margin-top: 16px;
    width: 100%;
    word-break: keep-all;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    & + & {
      margin-top: 10px;
    }
  }

  &__label {
    font-size: 13px;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    line-height: 16px;
    margin-right: 5px;

    &::after {
      content: ":";
    }
  }

  &__text {
    font-size: 13px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 16px;
    &_warning {
      color: rgba(244, 118, 26, 1);
    }

    &_primary {
      color: rgba(0, 211, 184, 1);
    }
  }
}

.chart-card {
  flex: 1;
  background: rgba(247, 247, 247, 1);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  & + & {
    margin-left: 10px;
  }

  &__title {
    font-size: 14px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    padding: 16px;
  }

  &__content {
    flex: 1;
    display: flex;
    padding: 16px;
    overflow: hidden;
  }

  &__gauge {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 16px;
  }
  &__gaugeBETTER {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 16px;
  }

  &__gauge-label {
    font-size: 14px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    margin-top: 5px;
    word-break: keep-all;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.mr-30 {
  margin-right: 30px;
}
</style>
